import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';

import {catchError, map} from 'rxjs/operators';

import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {GridService} from 'app/core-ui/abstract/basegrid/grid.service';
import {ConfigService} from 'app/core-ui/abstract/services/config.service';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';

@Injectable()
export class MailService extends GridService {
  constructor(
    http: HttpClient,
    configService: ConfigService,
    eventsEmitterService: EventsEmitterService,
    router: Router,
    logger: LogService,
  ) {
    super(http, configService, eventsEmitterService, router, logger, 'MailService');
  }

  initData(params: any): Observable<any> {
    return null;
  }

  getData(params: any): Observable<any> {
    let serviceUrl =
      this.baseUrl + this.serviceName + '/getInbox?' + this.urlParamsToString(params);
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  getDeleted(params: any): Observable<any> {
    let serviceUrl =
      this.baseUrl + this.serviceName + '/getDeleted?' + this.urlParamsToString(params);
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  getUnreadCount(): Observable<any> {
    let serviceUrl = this.baseUrl + 'MailService/countOfUnread';
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  getCount(): Observable<any> {
    let serviceUrl = this.baseUrl + 'MailService/getInboxCount';
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  getDeletedCount(): Observable<any> {
    let serviceUrl = this.baseUrl + 'MailService/getDeletedCount';
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  getMailDetails(mailId: string): Observable<any> {
    let serviceUrl = this.baseUrl + 'MailService/getMailDetails?' + 'mailId=' + mailId;
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  delete(list: string[]): Observable<any> {
    let serviceUrl = this.baseUrl + 'MailService/delete';

    var options = {
      method: 'POST',
      body: list,
    };

    return this.request(serviceUrl, options).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }

  restore(list: string[]): Observable<any> {
    let serviceUrl = this.baseUrl + 'MailService/restore';

    var options = {
      method: 'POST',
      body: list,
    };

    return this.request(serviceUrl, options).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }

  getFooter(params: any): Observable<any> {
    return of(null);
  }

  getHeader(params: any): Observable<any> {
    return of(null);
  }
}
